"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = exports.unRegister = exports.uiActions = exports.setIsVisibleGlobalLoader = exports.register = void 0;
var _reduxActions = require("redux-actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @deprecated use new actions
 */
var uiActions = exports.uiActions = (0, _reduxActions.createActions)({
  SET_UI_STATE: function SET_UI_STATE(value, path) {
    return {
      value: value,
      path: path
    };
  },
  SEND_ANALYTICS_REPORT: function SEND_ANALYTICS_REPORT(eventAction, eventLabel) {
    return {
      eventAction: eventAction,
      eventLabel: eventLabel
    };
  }
}, {
  prefix: 'tourscaner'
});
var _createActions = (0, _reduxActions.createActions)({
    register: function register(key, ui) {
      return _defineProperty({}, key, ui);
    },
    unRegister: function unRegister(key) {
      return key;
    },
    update: function update(key, ui) {
      return {
        key: key,
        ui: ui
      };
    },
    setIsVisibleGlobalLoader: function setIsVisibleGlobalLoader(visible) {
      return visible;
    }
  }, {
    prefix: 'tourscaner'
  }),
  register = exports.register = _createActions.register,
  setIsVisibleGlobalLoader = exports.setIsVisibleGlobalLoader = _createActions.setIsVisibleGlobalLoader,
  update = exports.update = _createActions.update,
  unRegister = exports.unRegister = _createActions.unRegister;